<template>
  <div>
    <!-- 表格 -->
    <Row>
      <Table
        :columns="tableCols"
        :data="data"
        :table="table"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        @on-selection-change="selectRow"
        ref="selection"
      >
      </Table>
    </Row>
    <Button type="primary" style="margin-top: 10px" @click="handleSelectAll">批量补货</Button>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import logo from "../../assets/logo.png";
import CheckList2 from "./checkList2.vue";

export default {
  props: {},
  data() {
    return {
      data: [],
      selectedConsumable: [],
      table: {
        mname: "consumables",
        key: "id",
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "货物信息",
          width: 460,
          align: "center",
          render: (h, p) => {
            return (
              <div style="display:flex; width:100%; padding:5px 0; align-items:center; text-align:left;">
                <el-image
                  style="width: 80px; height: 80px;flex-shrink: 0;"
                  src={
                    p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl
                  }
                  preview-src-list={[
                    p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl,
                  ]}
                >
                  {" "}
                  <div slot="error" class="image-slot">
                    <img style="width:80px;height:80px;" src={logo} />
                  </div>
                </el-image>
                <div style="flex: 1; margin-left: 10px;overflow: hidden;">
                  <div>
                    {p.row.brand} {p.row.name} {p.row.model}
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content={p.row.remark}
                    placement="top-start"
                  >
                    <div style="width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                      {p.row.remark}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content={p.row.performanceParameter}
                    placement="top-start"
                  >
                    <div style="width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                      {p.row.performanceParameter}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            );
          },
        },
        {
          title: "单价",
          key: "unitPrice",
          minWidth: 80,
          align: "center",
        },
        {
          title: "库存",
          key: "num",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.delItem(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  删除
                </Button>
              </div>
            );
          },
        },
      ],
    };
  },
  async created() {
    this.getData();
  },
  methods: {
    selectRow(selection) {
      this.selectedConsumable = selection;
    },
    async getData() {
      let res = await $utils.api.load(
        "admin/system/inventory/replenishmentList",
        {},
        "get"
      );
      if (res.code == 200) {
        this.data = res.rows;
      }
    },
    async delItem(row) {
      let id = row.id;
      let res = await $utils.api.load(`/admin/system/replenishment/${id}`, "", "DELETE");
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.getData();
        }, 100);
      }
    },
    handleSelectAll() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "补货",
          width: "1100px",
          height: "900px",
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <CheckList2
                style={{ margin: "0", color: "#19be6b" }}
                consumableInventory={this.selectedConsumable}
              ></CheckList2>
            );
          },
        });
      }, 500);
    },
    toCheckList() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.$Modal.success({
        closable: true,
        title: "补货",
        width: "1100px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList2
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            ></CheckList2>
          );
        },
      });
    },
  },
};
</script>
<style scoped>
.zong {
  color: black;
}
</style>
